import React, { useState, useEffect } from "react";
import { Card, Button, Tag, Typography, Row, Col, Space, Divider, Avatar, Tabs, Modal, Spin, message, Tooltip } from "antd";
import { DeleteOutlined, ArrowRightOutlined, QuestionCircleOutlined, UserOutlined, EditOutlined, ArrowLeftOutlined, LeftOutlined } from "@ant-design/icons";
import { applicationStatus } from "../../constants/DataConstants";
import MainLayout from "../pageHeader/MainLayout";
import { useLocation } from "react-router-dom";
import PreviewGeneralInfo from "./PreviewGeneralInfo";
import TabPane from "antd/lib/tabs/TabPane";
import ApplicationDetailsTab from "./ApplicationDetailsTab";
import FinancialStatementTab from "./FinancialStatementTab";
import "../../assets/dist/NewApplication/ApplicantPreview.css"
import ApplicationStatusTab from "./ApplicationStatusTab";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import _NewapplicationService from "../../modules/NewapplicationService";
import AssessmentTab from "./AssessmentTab";
import { useHistory } from "react-router-dom";
import { routes } from "../../routes/Routes";
import { COMMON_ERROR_MSG, RECORD_DELETED_MSG, SESSION_TOKEN } from "../../constants/constants";
import StatusTag from "../../components/StatusTag";
import LatestComments from "./LatestComments";
import SidebarLayout from "../BankerUI/SidebarLayout";
import "./Dashboard.scss";
const { Text, Title } = Typography;
const { confirm } = Modal;

export default function Dashboard() {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();
  let isAllStepsCompleted = false;
  try {
    isAllStepsCompleted = JSON.parse(localStorage.getItem("isAllStepsCompleted"));
  } catch (e) {
    isAllStepsCompleted = false;
  }
  const IsFromUploadPFS = JSON.parse(localStorage.getItem("IsFromUploadPFS"));

  let data = location.state;
  let applicationObjId = "";
  let applicationId = "";
  let applicationStatusId = null;
  let tabActiveKey = null;
  let emailId = '';

  if (data && data.email) {
    emailId = data.email;
  }

  if (data && data.activeKey) {
    tabActiveKey = data.activeKey;
  }
  if (data && data.applicationData && data.applicationData.Id) {
    applicationObjId = data.applicationData.Id;
  }

  if (data && data.applicationData && data.applicationData.ApplicationId) {
    applicationId = data.applicationData.ApplicationId;
  }

  if (data && data.applicationData && data.applicationData.Application_Status_Id) {
    applicationStatusId = data.applicationData.Application_Status_Id;
  }

  const [applnObjId] = useState(applicationObjId ? applicationObjId : localStorage.getItem("ApplicationObjId"));
  const [applnId, setApplnId] = useState(applicationId ? applicationId : localStorage.getItem("ApplicationId"));
  const [applnStatusId] = useState(applicationStatusId ? applicationStatusId : localStorage.getItem("ApplicationStatusId"));
  const [emailID] = useState(emailId ? emailId : localStorage.getItem("ApplicationEmailId"));
  const [IsKey] = useState(localStorage.getItem("IsKey"));
  const [applicantInfo, setApplicantInfo] = useState({});
  const [applicantFundInfo, setApplicantFundInfo] = useState([]);
  const RoleId = Number(localStorage.getItem("RoleId") ?? 0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  let activeKeyForTab = tabActiveKey ? tabActiveKey :
    ((localStorage.getItem("fromBalanceSheetScreen") == "false") && localStorage.getItem("fromUserLoginScreen") == "true") ? "1" :
      localStorage.getItem("fromBalanceSheetScreen") == "true" ? "2" : "1";

  const [activeKey, setActiveKey] = useState(activeKeyForTab);

  const previewTabChange = (key) => {
    setActiveKey(key);
  }

  const statusId = applnStatusId ? applnStatusId : localStorage.getItem("ApplicationStatusId");
  const statusNameNew = applicationStatus && applicationStatus.find(status => status.id == Number(statusId))?.name;

  const statusName = applicationStatus && applicationStatus.find(status => status.id == Number(applicantInfo && applicantInfo.Application_Status_Id))?.name;
  const appStatusId = localStorage.getItem("ApplicationStatusId");
  // const blockedStatuses = ["2", "3", "6", "7", "8", "9", "10"];

  const blockedStatuses = ["5", "7", "8", "10", "11", "12", "13", "14"];
  const canShowButton = (isAllStepsCompleted || IsFromUploadPFS) && !blockedStatuses.includes(appStatusId);

  useEffect(() => {
    fetchUserDetails();
  }, []);

  const fetchUserDetails = async () => {
    let reqObj = {
      Email: emailID,
      Password: IsKey,
      IsFirmAdmin: false,
    }
    setLoading(true);
    try {
      const res = await _NewapplicationService.userLogin(reqObj);
      if (res.data.IsSuccess) {
        setLoading(false);
        // message.success(res.data.Message || "User Logged in Successfully");
        localStorage.setItem(SESSION_TOKEN, res?.data?.Obj?.AuthToken);
        localStorage.setItem("userRole", res?.data?.Obj?.Role);
        localStorage.setItem("IsFirmAdminFlag", res?.data?.Obj?.IsFirmAdmin);
        localStorage.setItem("HasOtherRoleAssociation", res?.data?.Obj?.HasOtherRoleAssociation);
        //localStorage.setItem("Id", res?.data?.Obj?.Id);
        localStorage.setItem("ApplicationId", res?.data?.Obj?.Id);
        localStorage.setItem("BankerId", res?.data?.Obj?.BankerId);
        localStorage.setItem("loginEmail", reqObj.Email);

        localStorage.setItem("BankAdminId", res?.data?.Obj?.BankAdminId);
        localStorage.setItem("SponserIdForFirmLogin", res?.data?.Obj?.SponserId);
        localStorage.setItem("IsKey", reqObj.Password);

      } else {
        setLoading(false);
        message.error(res.data.Message || COMMON_ERROR_MSG);
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const deleteApplication = () => {
    confirm({
      title: "Are you sure, want to delete this Application?",
      icon: <ExclamationCircleOutlined />,
      okText: <span id="yesBtn">Yes</span>,
      cancelText: <span id="noBtn">No</span>,
      okType: "primary",
      onOk() {
        deleteApplicationObj();
      }
    });
  };

  const deleteApplicationObj = async () => {
    setLoading(true);
    try {
      const res = await _NewapplicationService.deleteApplicationByAppId(applnObjId ? applnObjId : localStorage.getItem("ApplicationObjId"));
      if (res.data.IsSuccess) {
        setLoading(false);
        message.success(res.data.Message ? res.data.Message : RECORD_DELETED_MSG);
        history.push({
          pathname: routes.myApplications.path,
          state: { email: emailID },
        });
      } else {
        setLoading(false);
        message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const submitApplication = () => {
    const statusId = localStorage.getItem("ApplicationStatusId");
    // const isResubmit = ["4", "5"].includes(statusId);
    const isResubmit = ["4", "9"].includes(statusId);
    let titleText = (localStorage.getItem("IsQuestionairCompleted") == "false" || localStorage.getItem("IsQuestionairCompleted") == null)
      ? `The Balance Sheet Questionnaire is incomplete. Please review it before submitting. Would you like to review it now?`
      : `Are you sure, want to ${isResubmit ? "Resubmit" : "Submit"} this Application?`;

    confirm({
      title: titleText,
      icon: <ExclamationCircleOutlined />,
      okText: <span id="yesBtn">Yes</span>,
      cancelText: <span id="noBtn">No</span>,
      okType: "primary",
      onOk() {
        if ((localStorage.getItem("IsQuestionairCompleted") == "false" || localStorage.getItem("IsQuestionairCompleted") == null)) {
          history.push({
            pathname: routes.questionnaire.path,
            state: { email: emailID, isFromDashboard: true },
          });
        } else {
          submitApplicationObj();
        }
      }
    });
  };

  const submitApplicationObj = async () => {
    setLoading(true);
    try {
      const appObjId = localStorage.getItem("ApplicationObjId");
      const appObjectId = appObjId ? parseInt(appObjId) : null;

      const reqObj = {
        "Id": appObjectId,
        // "Application_Status_Id": ["4", "5"].includes(localStorage.getItem("ApplicationStatusId")) ? 6 : 2, // If status is Revision Requested or Action Required, set to Resubmitted (6), else set to Submitted
        "Application_Status_Id": ["9"].includes(localStorage.getItem("ApplicationStatusId")) ? 10 : 5, // If status is Revision Requested or Action Required, set to Resubmitted (6), else set to Submitted
         RoleId: RoleId || null
      }
      const res = await _NewapplicationService.submitApplicationByAppId(reqObj);
      if (res.data.IsSuccess) {
        setLoading(false);
        message.success(res.data.Message ? res.data.Message : "Application submitted successfully!");
        localStorage.setItem("IsSwitchFirmAdmin", JSON.stringify(false));
        localStorage.setItem("BankAdminId", res?.data?.Obj?.BankAdminId);
        history.push({
          pathname: routes.myApplications.path,
          state: { email: emailID },
        });
      } else {
        setLoading(false);
        message.error(COMMON_ERROR_MSG);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  useEffect(() => {
    getApplicantAssesmentInfoByApplicationId(Number(localStorage.getItem("ApplicationObjId")));
  }, [])

  const getApplicantAssesmentInfoByApplicationId = async (applicationObjId) => {
    setLoading(true);
    try {
      const res = await _NewapplicationService.getApplicantAssesmentInfoByApplicationId(Number(applicationObjId));
      //debugger;
      if (res.data.IsSuccess) {
        let resObj = res?.data.Obj;
        console.log(resObj.applicantGeneralInfoModel.FirstName, "resObj.applicantGeneralInfoModel")
        setApplicantInfo(resObj.applicantGeneralInfoModel ? resObj.applicantGeneralInfoModel : {});
        setApplicantFundInfo(resObj.listsponserFundModel ? resObj.listsponserFundModel : []);
        localStorage.setItem("ApplicationStatusId", resObj?.applicantGeneralInfoModel ? resObj.applicantGeneralInfoModel.Application_Status_Id : localStorage.getItem("ApplicationStatusId"));
        localStorage.setItem("ApplicantName", resObj.applicantGeneralInfoModel ? `${resObj.applicantGeneralInfoModel.FirstName || ""} ${resObj.applicantGeneralInfoModel.LastName || ""}`.trim() : "");
        const newAppId = resObj.applicantGeneralInfoModel ? resObj.applicantGeneralInfoModel.ApplicationId : null;
        localStorage.setItem("ApplicationId", newAppId || localStorage.getItem("ApplicationId"));
        if (newAppId) setApplnId(newAppId);

        setLoading(false);
      } else {
        message.error(res.data.Message || COMMON_ERROR_MSG);
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const goToMyApplications = () => {
    history.push({ pathname: routes.myApplications.path });
  }
  // console.log(statusId, "statusId onback")
  //  console.log(statusName, "statusName onback ")
  return (
    <Spin spinning={loading}>
      <SidebarLayout>
        <Row justify="space-between" align="middle" className="mb30">
          <Col>
            <Space direction="vertical" size={4}>
              {/* <Title level={5} style={{ margin: 0 }}>
                Application: <Text strong>{applnId ? applnId : localStorage.getItem("ApplicationId")}</Text>
              </Title> */}
              <Text className="page-title">
                Application: <span>{applnId ? applnId : localStorage.getItem("ApplicationId")} </span>
              </Text>

              <Text className="application-status">
                Status  :  <span><StatusTag statusId={applicantInfo?.Application_Status_Id == 2 ? 1 :applicantInfo?.Application_Status_Id} /></span>
              </Text>

              {/* <Text className="application-status">
                Status  :  <span><StatusTag statusId={applicantInfo?.Application_Status_Id == 2 ? 15 : applicantInfo?.Application_Status_Id} /></span>
              </Text> */}
              {/* {applicantInfo?.Application_Status_Id == 2 && (
                <Text className="application-status-message">
                  Awaiting Bank AML/KYC verification and Credit Bureau document upload.
                </Text>
              )} */}

            </Space>
          </Col>

          <Col>
            <Space>
              {(localStorage.getItem("fromUserLoginScreen") === "true" ||
                localStorage.getItem("IsFromManualFlow") === "true" ||
                localStorage.getItem("IsFromUploadPFS") === "true"
              ) && (
                  <Button
                    type="default"
                    icon={<LeftOutlined />}
                    onClick={goToMyApplications}
                  >
                    Go to My Applications
                  </Button>
                )}
              {/* {["1", "5"].includes(localStorage.getItem("ApplicationStatusId")) && */}
              {["1","2","4","9"].includes(localStorage.getItem("ApplicationStatusId")) &&
                <Button
                  className="delete-btn"
                  type="default"
                  icon={<DeleteOutlined />}

                  onClick={deleteApplication}
                >
                  Delete
                </Button>
              }
              {canShowButton && 
                // <Button
                //   type="primary"
                //   icon={<ArrowRightOutlined />}
                //   onClick={submitApplication}
                // >
                //   {/* {["4", "5"].includes(appStatusId) ? "Resubmit" : "Submit"} */}
                //   {["9"].includes(appStatusId) ? "Resubmit" : "Submit"}
                // </Button>

                 ["1","2","4","9"].includes(appStatusId) && (
                  <Tooltip
                    // title={appStatusId === "2" ? "Application submission is unavailable until the Compliance Administrator Started the AML/KYC review process." : ""}
                    placement="bottom"
                    overlayStyle={{ maxWidth: 700 }}
                  >
                    <Button
                      type="primary"
                      icon={<ArrowRightOutlined />}
                      onClick={submitApplication}
                      
                    >
                      {appStatusId === "9" ? "Resubmit" : "Submit"}
                    </Button>
                  </Tooltip>
            )}

              </Space>


          </Col>
        </Row>
        <Row gutter={30}>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={7}
            xl={7}
          >
            <PreviewGeneralInfo
              applnObjId={applnObjId}
              applicantInfo={applicantInfo}
              applicantFundInfo={applicantFundInfo}
            />
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={17}
            xl={17}>
            {/* {applicantInfo?.Application_Status_Id && Number(applicantInfo.Application_Status_Id) === 5 ? ( */}
            {applicantInfo?.Application_Status_Id && Number(applicantInfo.Application_Status_Id) === 9 ? (
              <div className="mb15">
                <LatestComments />
              </div>
            ) : null}

            <Tabs
              className="previewTab"
              activeKey={activeKey}
              onChange={previewTabChange}
            >
              {((localStorage.getItem("fromBalanceSheetScreen") == "false") || localStorage.getItem("fromUserLoginScreen") == "true") &&
                < TabPane tab={<span id="setApplicationStatusTab">Application Status</span>} key="1">
                  <div>
                    <ApplicationStatusTab activeKey={activeKey} />
                  </div>
                </TabPane>
              }
              <TabPane tab={<span id="setAssessmentTab">Assessment</span>} key="2">
                <div>
                  <AssessmentTab activeKey={activeKey} />
                </div>
              </TabPane>
              <TabPane tab={<span id="setApplicationDetailsTab">Application Details</span>} key="3">
                <div>
                  <ApplicationDetailsTab activeKey={activeKey} />
                </div>
              </TabPane>
              <TabPane tab={<span id="setFinancialStatementTab">Financial Statement</span>} key="4">
                <div>
                  <FinancialStatementTab activeKey={activeKey} />
                </div>
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </SidebarLayout>
    </Spin>
  );
}